import { computed, DestroyRef, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { useBeforeUnload } from '@rp/utils';
import { isEqual } from 'lodash';

import { IHaveChanges } from '../../models';

export abstract class ConfirmOnLeaveComponent implements IHaveChanges {
  initFormState = signal<object | null>(null);
  abstract form: FormGroup;

  protected readonly _destroyRef = inject(DestroyRef);

  constructor() {
    useBeforeUnload(
      computed(() => !this.haveChanges()),
      this._destroyRef,
    );
  }

  saveInitFormState(): void {
    this.initFormState.set(this.form.getRawValue());
  }

  resetInitFormState(): void {
    this.initFormState.set(null);
  }

  haveChanges(): boolean {
    return this.initFormState() && !isEqual(this.initFormState(), this.form.getRawValue());
  }
}
